import { t } from '@lingui/core/macro'

import { ConsultationStatus, ConsultationType } from '@/core/graphql/types'

export function getBgColorByStatus(status: ConsultationStatus): string {
  switch (status) {
    case ConsultationStatus.Accepted:
    case ConsultationStatus.Active:
    case ConsultationStatus.Completed:
      return 'bg-green-50'
    case ConsultationStatus.Scheduled:
      return 'bg-blue-50'
    case ConsultationStatus.Canceled:
    case ConsultationStatus.Refused:
      return 'bg-red-50'
    default:
      return 'bg-gray-50'
  }
}

export function getTextColorByStatus(status: ConsultationStatus): string {
  switch (status) {
    case ConsultationStatus.Accepted:
    case ConsultationStatus.Active:
    case ConsultationStatus.Completed:
      return 'text-green-500'
    case ConsultationStatus.Scheduled:
      return 'text-blue-500'
    case ConsultationStatus.Canceled:
    case ConsultationStatus.Refused:
      return 'text-red-500'
    default:
      return 'text-gray-500'
  }
}

export function getConsultationStatusLabel(status: ConsultationStatus): string {
  switch (status) {
    case ConsultationStatus.Accepted:
      return t`Accepted`
    case ConsultationStatus.Active:
      return t`Active`
    case ConsultationStatus.Canceled:
      return t`Canceled`
    case ConsultationStatus.Completed:
      return t`Completed`
    case ConsultationStatus.Refused:
      return t`Refused`
    case ConsultationStatus.Scheduled:
      return t`Scheduled`
    default:
      return status
  }
}

export function getConsultationTypeLabel(type: ConsultationType): string {
  switch (type) {
    case ConsultationType.Classic:
      return t`Classic`
    case ConsultationType.Emergency:
      return t`Emergency`
    case ConsultationType.Local:
      return t`Local`
    case ConsultationType.MeetingOnly:
      return t`Video meeting`
    default:
      return type
  }
}
